export default __webpack_public_path__ + "static/media/570.36ba55b4.png";